module.exports = __webpack_public_path__ + "img/left5.d9c12ec1.png";